import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=414342dd&scoped=true&"
import script from "./Keywords.vue?vue&type=script&lang=js&"
export * from "./Keywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414342dd",
  null
  
)

export default component.exports